<template>
  <LayoutCenter tag="form" @submit.prevent="onSubmit">
    <div class="max-w-md w-full flex flex-col items-center">
      <BaseLoader v-if="submitting" class="w-10 h-10" />
      <template v-else-if="!submitted">
        <input
          class="newsletter-input"
          placeholder="FIRST NAME"
          v-model="firstName"
        />
        <input
          class="newsletter-input"
          placeholder="LAST NAME"
          v-model="lastName"
        />
        <input
          class="newsletter-input"
          placeholder="EMAIL ADDRESS"
          v-model="email"
        />
        <div v-if="typeof valid === 'string'" class="mt-4 text-red-500">
          {{ valid }}
        </div>
      </template>
      <div v-else-if="submitted" class="text-center text-3xl">
        Thank you. Your subscription has been confirmed.
      </div>
    </div>

    <template #footer>
      <span v-if="submitting" class="uppercase tracking-super">
        Submitting...
      </span>
      <button
        v-else-if="!submitted"
        class="relative group uppercase tracking-super focus:outline-none"
        :disabled="submitting"
      >
        <span class="link-dot-absolute" /> Submit
      </button>
      <RouterLink
        v-else-if="submitted"
        class="relative group uppercase tracking-super"
        :to="{ name: 'home' }"
      >
        <span class="link-dot-absolute" /> Return to Stories
      </RouterLink>
    </template>
  </LayoutCenter>
</template>

<script lang="ts">
import axios from 'axios';
import BaseLoader from '@/components/BaseLoader.vue';
import LayoutCenter from '@/components/LayoutCenter.vue';
import { setMeta } from '@/store';
import { useForm } from '@/store/form';
import { defineComponent, ref } from 'vue';

export default defineComponent({
  components: {
    BaseLoader,
    LayoutCenter,
  },
  setup() {
    const submitting = ref(false);
    const submitted = ref<string | boolean>(false);

    const { firstName, lastName, email, valid, validate } = useForm();

    const postSubscription = async () => {
      try {
        const params = new URLSearchParams();
        params.append('email', email.value);
        params.append('firstname', firstName.value);
        params.append('lastname', lastName.value);
        await axios.post(process.env.VUE_APP_SUB_ENDPOINT, params);
        submitted.value = true;
      } catch (e) {
        submitted.value = false;
        valid.value = 'Something went wrong, please try again later.';
      } finally {
        submitting.value = false;
      }
    };

    const onSubmit = () => {
      valid.value = validate(true);
      if (valid.value === true) {
        submitting.value = true;
        postSubscription();
      }
    };
    setMeta({ title: 'Subscribe' });

    return {
      submitting,
      submitted,
      firstName,
      lastName,
      email,
      valid,
      onSubmit,
    };
  },
});
</script>

<style lang="postcss" scoped>
.newsletter-input {
  @apply my-1 border-b border-black placeholder-gray-500 outline-none bg-transparent;
  @apply w-full pt-1;
}

/* .newsletter-input {
  @apply bg-transparent;
  @apply my-1 border-b border-black placeholder-gray-500 outline-none;
  @apply w-full;
  @apply pt-3 pb-2 text-xl;
}
@screen md {
  .newsletter-input {
    @apply pt-4 pb-3 text-3xl;
  }
} */
</style>
